module.exports = __webpack_public_path__ + "media/fonts/sovremennic/SovremennicCondensed-Thin-15fec07921bd911ed72b9f7f8e81af3f.ttf";